export function buildCriiptoLoginAdditionalParameters(
  forcePromptLogin: boolean,
  additionalParameters: Record<string, string>,
): Record<string, string> {
  if (!forcePromptLogin) {
    return additionalParameters;
  }

  return {
    ...additionalParameters,
    prompt: 'login',
  };
}
